import { Component, OnInit } from '@angular/core';
import { WizardNavigationComponentBase } from '../wizard-navigation/wizard-navigation-base.component';
import { WizardFlowServiceBase } from '../../services/wizard/wizard-flow-service.base';
import { LocalizedEditService } from '../../transloco/localized-edit.service';
import { StepTitleChangedEvent } from './wizard-horizontal-nav-step.component';

@Component({
    selector: 'wizard-horizontal-nav',
    templateUrl: 'wizard-horizontal-nav.component.html',
    standalone: false
})
export class WizardHorizontalNavComponent extends WizardNavigationComponentBase implements OnInit {

  constructor(
    wizardFlowService: WizardFlowServiceBase,
    public readonly i18n: LocalizedEditService,
  ) {
    super(wizardFlowService);
  }

  onStepTitleChanged = (e: StepTitleChangedEvent) => {
    const changedStep = this.navGroups[e.stepIndex];
    this.i18n.set(changedStep, 'title', e.newTitle);
  }
}
